// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a_plQ","right":"styles_right__2xL-D"};